import type { ComponentProps } from "react"

export default function PropertySports(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M16 2.66675C13.3629 2.66675 10.785 3.44873 8.59236 4.91382C6.39971 6.37891 4.69074 8.46129 3.68157 10.8976C2.6724 13.334 2.40836 16.0149 2.92283 18.6013C3.4373 21.1877 4.70717 23.5635 6.57188 25.4282C8.43658 27.2929 10.8123 28.5627 13.3988 29.0772C15.9852 29.5917 18.6661 29.3276 21.1024 28.3185C23.5388 27.3093 25.6211 25.6003 27.0862 23.4077C28.5513 21.215 29.3333 18.6372 29.3333 16.0001C29.3294 12.4651 27.9234 9.07592 25.4238 6.57628C22.9241 4.07663 19.535 2.67063 16 2.66675ZM25.164 21.4321L21.7426 21.1081L19.3333 18.3267L19.8173 15.9054L23.732 14.7387L26.6346 16.6054C26.5412 18.3094 26.0366 19.9655 25.164 21.4321ZM10.2573 21.1081L6.83597 21.4321C5.96451 19.9647 5.46128 18.3082 5.3693 16.6041L8.27197 14.7374L12.1866 15.9041L12.6666 18.3267L10.2573 21.1081ZM24.816 10.0067L23.1533 12.8241L18.8213 14.1161L17 12.7507V8.33341L19.4253 5.90808C21.6188 6.65415 23.5106 8.09254 24.816 10.0067ZM12.5746 5.90808L15 8.33341V12.7507L13.1786 14.1161L8.84663 12.8241L7.18397 10.0067C8.48931 8.09254 10.3811 6.65415 12.5746 5.90808ZM12.028 25.8921L11.592 22.6241L13.8666 20.0001H18.1333L20.4 22.6241L19.964 25.8921C17.4167 26.9249 14.5673 26.9249 12.02 25.8921H12.028Z"
        fill={fill}
      />
    </svg>
  )
}
